import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApisService } from '../../services';
import { CommunicationService } from '../../services/communication.service';
declare var $: any;

@Component({
    selector: 'app-send-sms',
    templateUrl: './send-sms.component.html',
    styleUrls: ['./send-sms.component.scss'],
    standalone: false
})
export class SendSmsComponent implements OnInit {

  public frmSMS: any = {};

  public error: string = "";
  public message: string = "";

  constructor(
    private comm: CommunicationService,
    private apis: ApisService,
    private http: HttpClient
  ) {
    this.comm.fnGetSmsSettings();
  }

  fnOpenSendSmsModal(id: any, source: string="gr") {
    $('#sendSmsModal').modal('show');
    if(source === "category") {
      this.http.get<any>(this.apis.categories+'/'+id)
      .subscribe(resp => {
        this.frmSMS = { id: resp.data.id, source: source, itemNo: resp.data.grNo, numbers: resp.data.consignorMobile + (resp.data.consignorMobile && resp.data.consigneeMobile?','+resp.data.consigneeMobile:resp.data.consigneeMobile), message: this.comm.smsList.find(sms=>sms.category === resp.data.status)['settingOptions']['message'] };
      }, error => {
        this.error = error;
      })
    } else if(source === "topic") {
      this.http.get<any>(this.apis.topics+'/'+id)
      .subscribe(resp => {
        this.frmSMS = { id: resp.data.id, source: source, itemNo: resp.data.challanNo, numbers: resp.data.consignorMobile + (resp.data.consignorMobile && resp.data.consigneeMobile?','+resp.data.consigneeMobile:resp.data.consigneeMobile), message: this.comm.smsList.find(sms=>sms.category === resp.data.status)['settingOptions']['message'] };
      }, error => {
        this.error = error;
      })
    } else {
      this.http.get<any>(this.apis.questions+'/'+id)
      .subscribe(resp => {
        this.frmSMS = { id: resp.data.id, source: source, itemNo: resp.data.challanNo, numbers: resp.data.consignorMobile + (resp.data.consignorMobile && resp.data.consigneeMobile?','+resp.data.consigneeMobile:resp.data.consigneeMobile), message: this.comm.smsList.find(sms=>sms.category === resp.data.status)['settingOptions']['message'] };
      }, error => {
        this.error = error;
      })
    }
    
  }

  fnSendSMS() {
    let payload: any = {numbers: this.frmSMS.numbers, messagse: this.frmSMS.message};

    this.http.post<any>(this.apis.sendSMS, payload)
      .subscribe(resp => {
        
        
        setTimeout(() => {
          this.fnCloseSendSmsModal();
        }, 1000);
      }, error => {
        this.error = error;
      })
  }

  fnCloseSendSmsModal() {
    $('#sendSmsModal').modal('hide');
  }

  ngOnInit(): void {
  }

}
